export default {
  undefined: 0,
  noAnswer: 1,
  marriagePending: 2,
  married: 3,
  other: 4,
  separated: 5,
  single: 6,
  singleWithPartner: 7
};


// WEBPACK FOOTER //
// ./src/constants/marital-statuses.js